function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M347.429,0h12.5V18.75h-12.5Z",
  transform: "translate(-330.465)",
  fill: "#046eab"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M43.3,789.2H3.125L0,777.143H46.429Z",
  transform: "translate(0 -739.197)",
  fill: "#19457a"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M3.125,415.25,0,403.2,16.964,384h12.5Z",
  transform: "translate(0 -365.25)",
  fill: "#1590cf"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M530.3,484.822,512,466.072l7.589-8.929,13.839,15.625Z",
  transform: "translate(-487 -434.822)",
  fill: "#046eab"
});

var SvgMachineLearningServiceWorkspaces = function SvgMachineLearningServiceWorkspaces(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46.429,
    height: 50,
    viewBox: "0 0 46.429 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMachineLearningServiceWorkspaces, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/machine_learning_service_workspaces.3a9a761f.svg";
export { ForwardRef as ReactComponent };